import React, { useState, useEffect } from 'react';
import {
  Image,
  Dropdown,
  Icon,
  Input,
  Button,
} from 'semantic-ui-react';
import PropTypes from 'prop-types';

import './Dropdown.scss';
import Wrapper from 'hoc/Wrapper';

const SavedAccountDropdown = ({
  options,
  currentOption,
  onSaveAccountListChange,
  search,
  setCurrentOption,
  disabled,
  placeholder,
  customstyle,
  customStyleSelector,
  bottomAction,
  actionHandler,
  actionLabel,
  setSelectedSavedAccount,
  setShowForm,
  setCurrentProviderOption,
}) => {
  let name;
  const newOptions =
    options &&
    options?.map(option => {
      // select country
      if (
        option.Logo &&
        option.PhoneNumber &&
        option.AccountNumber &&
        option.TargetType
      ) {
        name = 'CountryCode';
        return {
          ...option,
          Img: option.Logo,
          Title: option?.PhoneNumber || option.AccountNumber,
          names: `${option?.FirstName || ''} ${option?.LastName ||
            ''}`,
          TargetType: option?.TargetType || '',
          PhoneNumber: option?.PhoneNumber || '',
        };
      }
      // select phoneNumber
      if (
        (option.PhonePrefix || option?.Phone) &&
        option.PhoneFlag &&
        option.PhoneNumber &&
        option?.Category
      ) {
        name = 'PhoneNumber';
        return {
          Title: `+${option?.PhonePrefix || ''} ${
            option?.PhoneNumber
          }`
            .replaceAll('+ +', '+')
            .replaceAll('++', '+'),
          Img: option?.PhoneFlag,
        };
      }
    });

  let newCurrentOption;
  if (currentOption && currentOption.TargetType) {
    newCurrentOption = {
      Title: currentOption.PhoneNumber || currentOption.Title,
      Img: currentOption.Logo || currentOption.Logo,
      TargetType: currentOption.TargetType,
      PhoneNumber: currentOption.PhoneNumber,
    };
  } else {
    newCurrentOption = currentOption;
  }

  const wrapperId = `input-${Math.ceil(Math.random() * 10000)}`;
  const [filteredOptions, setFilteredOptions] = useState(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (newOptions) {
      setFilteredOptions(newOptions);
    }
  }, [options]);
  const checkClickInput = event => {
    const { target = {} } = event || {};
    if (target.classList && target.id === wrapperId) {
      return setOpen(false);
    }
    return null;
  };

  useEffect(() => {
    document.addEventListener('mousedown', checkClickInput);
    return () => {
      document.removeEventListener('mousedown', checkClickInput);
    };
  });

  return (
    <>
      <div
        id={wrapperId}
        style={{
          display: open ? 'block' : 'none',
          background: 'transparent',
          width: '100%',
          height: '100%',
          position: 'fixed',
          top: '0',
          left: '0',
        }}
      />

      <Dropdown
        placeholder="Select"
        id={wrapperId}
        disabled={disabled}
        style={{ maxWidth: customStyleSelector ? '100%' : 'auto' }}
        className="custom-dropdown"
        open={open}
        trigger={
          <span
            className="dropdown-trigger"
            onClick={() => setOpen(!open)}
            tabIndex={-1}
            onKeyDown={() => setOpen(!open)}
            role="button"
          >
            <div className="dropdown-wallet">
              {newCurrentOption.hasOwnProperty('Logo') === false ? (
                <span>{placeholder}</span>
              ) : (
                <Wrapper>
                  <Image
                    src={newCurrentOption && newCurrentOption.Logo}
                    className="inline"
                  />
                  <div>
                    <div>
                      {newCurrentOption && (
                        <>
                          {(newCurrentOption?.fistName &&
                            newCurrentOption?.fistName) ||
                            newCurrentOption?.phoneNumber}
                        </>
                      )}
                    </div>
                  </div>
                </Wrapper>
              )}
            </div>
            {!disabled && (
              <Icon name="caret down" className="inline" />
            )}
          </span>
        }
        icon={null}
      >
        <Dropdown.Menu
          style={{
            width: customstyle ? 'auto' : '100%',
            maxWidth: customstyle ? 'auto' : '100%',
          }}
        >
          {search && (
            <Input
              tabIndex={0}
              icon="search"
              autoFocus
              iconPosition="left"
              onSaveAccountListChange={({ target: { value } }) => {
                setFilteredOptions(
                  newOptions?.filter(option =>
                    option?.Title.toLowerCase().includes(
                      value.toLowerCase(),
                    ),
                  ),
                );
              }}
            />
          )}
          <Dropdown.Menu scrolling search={search}>
            {filteredOptions?.map(
              option =>
                option !== undefined && (
                  <Dropdown.Item
                    key={option?.Title}
                    onClick={() => {
                      setShowForm(true);
                      setOpen(false);
                      onSaveAccountListChange({
                        target: {
                          name,
                          value: option?.TargetType ?? option?.Title,
                        },
                      });
                      setCurrentOption({
                        ...option,
                      });
                      setCurrentProviderOption(null);

                      setSelectedSavedAccount({
                        Logo: option?.Img,
                        fistName: option?.FirstName,
                        lastName: option?.LastName,
                        phoneNumber: option?.PhoneNumber,
                        targetType: option?.TargetType,
                      });
                    }}
                  >
                    <span className="dropdown-trigger">
                      <div className="dropdown-wallet">
                        <Image src={option?.Img} className="inline" />
                        <div>
                          <div>
                            {option?.FirstName || ''}{' '}
                            {option?.LastName || ''}
                          </div>
                          <div>{option?.Title}</div>
                        </div>
                      </div>
                    </span>
                  </Dropdown.Item>
                ),
            )}
          </Dropdown.Menu>
          {bottomAction === true && actionLabel?.length && (
            <Button
              className="dropdown__button"
              onClick={actionHandler}
              basic
            >
              <Icon disabled name="add" />
              {actionLabel || global.translate('Add')}
            </Button>
          )}
        </Dropdown.Menu>
      </Dropdown>
    </>
  );
};

SavedAccountDropdown.defaultProps = {
  options: [{}],
  currentOption: undefined,
  onSaveAccountListChange: () => null,
  search: false,
  setCurrentOption: () => {},
  disabled: false,
  placeholder: '',
  customstyle: false,
  customStyleSelector: false,
  bottomAction: PropTypes.bool,
  actionLabel: PropTypes.string,
  actionHandler: PropTypes.func,
};

SavedAccountDropdown.propTypes = {
  options: PropTypes.arrayOf(PropTypes.instanceOf(Object)),
  currentOption: PropTypes.instanceOf(Object),
  onSaveAccountListChange: PropTypes.func,
  search: PropTypes.bool,
  setCurrentOption: PropTypes.func,
  disabled: PropTypes.bool,
  placeholder: PropTypes.string,
  customstyle: PropTypes.bool,
  customStyleSelector: PropTypes.bool,
  bottomAction: false,
  actionLabel: '',
  actionHandler: () => {},
};

export default SavedAccountDropdown;
